import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';

const Message = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-2181391309"
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2181391309"
  }, ["div.jsx-2181391309{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;}"]));
};

Message.propTypes = {
  children: PropTypes.string.isRequired
};
export { Message };